<template>
  <div class="">
    <b-row>
      <b-col cols="8">
        <h5>
          {{ $lang.person_know }}
          <span v-b-tooltip.hover :title="$lang.person_know_tooltip"
            ><i class="fa fa-info-circle text-info"></i
          ></span>
        </h5>
      </b-col>
      <b-col cols="4">
        <b-button
          variant="success"
          class="float-right"
          @click="addPersonColumn"
        >
          {{ $lang.add_person }}
        </b-button>
      </b-col>
    </b-row>
    <b-row v-for="(person, key) in $v.items.$each.$iter" :key="`person-${key}`">
      <personRelationForm
        ref="personRelationForm"
        :person="person"
        :person_key="key"
        @removePersonColumn="removePersonColumn"
        :person_description="$lang.person_relation_description"
      />
    </b-row>
  </div>
</template>

<script>
import personRelationForm from "./../forms/personRelationForm";
import { required } from "vuelidate/lib/validators";
export default {
  components: {
    personRelationForm,
  },
  inject: ["personRelationCodeRepository"],

  validations: {
    items: {
      $each: {},
    },
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    async removePersonColumn(person, index, key) {
      try {
        const response = await this.personRelationCodeRepository.delete(
          person.$model.code,
          person.$model.id
        );
        this.$notify.success(response.data.message);
        this.workExperience[index].persons.splice(key, 1);
        return true;
      } catch (error) {
        this.$generateError(error);
        return false;
      }
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        this.isLoading = false;
        return;
      }
      return this.items;
    },
    addPersonColumn() {
      const data = {
        mobile: null,
        name: null,
        family: null,
        gender_selected: null,
        regional_municipality: null,
        description: null,
        location_selected: null,
      };
      this.items.push(data);
    },
  },
};
</script>
